import { TableEmptyState } from '@practium/ui';
import type { UserDTO } from '../../../types';
import { applyPhoneMask } from '../../../utils/masks';
import styles from '../PeopleTable.module.css';

interface UsersTableProps {
	users: UserDTO[];
	onRowClick?: (id: string) => void;
}

export const UsersTable = ({ users, onRowClick }: UsersTableProps) => {
	if (users.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum usuário encontrado"
				subtitle="Adicione um usuário para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Sobrenome</th>
						<th>Telefone</th>
						<th>E-mail</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{users.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.surName}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.phoneNumber ? applyPhoneMask(item.phoneNumber) : '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.email}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${item.status === true ? styles.statusActive : styles.statusInactive
										}`}
								>
									{item.status === true ? 'Ativo' : 'Inativo'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
